<mojo-viewbar></mojo-viewbar>
<mojo-page-title title="Navigation Error"></mojo-page-title>
<section class="surface-border border-round surface-section border-1 border-red-500">

  <header class="p-3 bg-red-500 border-round-top">
    <h5 class="m-0 text-white">404: Not found</h5>
  </header>

  <div class="p-3">The item you were looking for was not found.</div>

</section>
